import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Skeleton, SkeletonItem } from 'element-ui';
let TaskSkeleton = class TaskSkeleton extends Vue {
    skeletonLoading;
};
__decorate([
    Prop({ default: true, type: Boolean })
], TaskSkeleton.prototype, "skeletonLoading", void 0);
TaskSkeleton = __decorate([
    Component({
        name: 'TaskSkeleton',
        components: {
            'el-skeleton': Skeleton,
            'el-skeleton-item': SkeletonItem,
        },
        i18n: {
            messages: {
                en: {},
                zh: {},
            },
        },
    })
], TaskSkeleton);
export default TaskSkeleton;
